exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  background: #eee; }\n  @media only screen and (max-width: 1023px) {\n    .container {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column; } }\n  .container #mapify-logo {\n    background-image: url(\"/assets/img/mapeo_logo.png\");\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    cursor: pointer;\n    height: 75px;\n    left: 10px;\n    position: fixed;\n    top: 10px;\n    width: 75px;\n    z-index: 10; }\n  @media only screen and (max-width: 1023px) {\n      .container #mapify-logo {\n        background-image: url(\"/assets/img/mapeo_mobile.png\");\n        background-size: contain;\n        height: 20px;\n        width: 63px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/app/components/editor/editor.component.scss
// module id = ../../../../../src/app/components/editor/editor.component.scss
// module chunks = main